window.location.replace('https://scene.yayya.live/app/docs/privacy-policy-ios');

export default function PrivacyPolicyIOS() {
  return null;
}



// WEBPACK FOOTER //
// src/pages/app/privacypolicy_ios/index.js